// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.video-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid #E9EDF7;
  background: #fff;
}

/* MEDIA */
.video-media {
  height: 220px;
  flex-shrink: 0;
  background: #000;
  position: relative;
  overflow: hidden;
}

/* BADGES PREMIUM */
.video-badge {
  position: absolute;
  z-index: 10;

  display: flex;
  align-items: center;
  gap: 6px;

  font-size: 11px;
  font-weight: 800;

  padding: 4px 10px;
  border-radius: 999px;

  backdrop-filter: blur(10px);
  letter-spacing: 0.4px;

  box-shadow: 0 6px 18px rgba(0,0,0,0.15);
}

/* POSITION */
.video-badge--position {
  top: 12px;
  left: 12px;

  background: rgba(0,0,0,0.65);
  color: #fff;
}

/* STATUS BASE */
.video-badge--status {
  top: 12px;
  right: 12px;
}

/* ACTIVE */
.video-badge--status.active {
  background: rgba(1, 181, 116, 0.15);
  color: #01B574;
  border: 1px solid rgba(1, 181, 116, 0.4);
}

/* INACTIVE */
.video-badge--status.inactive {
  background: rgba(238, 93, 108, 0.15);
  color: #EE5D6C;
  border: 1px solid rgba(238, 93, 108, 0.4);
}

/* CONTENT */
.video-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
}

/* TITLE */
.video-title {
  font-weight: 800;
  font-size: 15px;
  line-height: 1.2;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  height: 40px;
}

/* DESCRIPTION */
.video-desc {
  font-size: 12px;
  color: #A3AED0;
  margin-top: 8px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  height: 38px;
}

/* FOOTER */
.video-footer {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/GuideVideos/GuideVideoCard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,eAAe;EACf,gBAAgB;;EAEhB,iBAAiB;EACjB,oBAAoB;;EAEpB,2BAA2B;EAC3B,qBAAqB;;EAErB,uCAAuC;AACzC;;AAEA,aAAa;AACb;EACE,SAAS;EACT,UAAU;;EAEV,4BAA4B;EAC5B,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,WAAW;AACb;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;;EAE5B,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,eAAe;;EAEf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;;EAE5B,gBAAgB;EAChB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.video-card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 24px;\n  border: 1px solid #E9EDF7;\n  background: #fff;\n}\n\n/* MEDIA */\n.video-media {\n  height: 220px;\n  flex-shrink: 0;\n  background: #000;\n  position: relative;\n  overflow: hidden;\n}\n\n/* BADGES PREMIUM */\n.video-badge {\n  position: absolute;\n  z-index: 10;\n\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  font-size: 11px;\n  font-weight: 800;\n\n  padding: 4px 10px;\n  border-radius: 999px;\n\n  backdrop-filter: blur(10px);\n  letter-spacing: 0.4px;\n\n  box-shadow: 0 6px 18px rgba(0,0,0,0.15);\n}\n\n/* POSITION */\n.video-badge--position {\n  top: 12px;\n  left: 12px;\n\n  background: rgba(0,0,0,0.65);\n  color: #fff;\n}\n\n/* STATUS BASE */\n.video-badge--status {\n  top: 12px;\n  right: 12px;\n}\n\n/* ACTIVE */\n.video-badge--status.active {\n  background: rgba(1, 181, 116, 0.15);\n  color: #01B574;\n  border: 1px solid rgba(1, 181, 116, 0.4);\n}\n\n/* INACTIVE */\n.video-badge--status.inactive {\n  background: rgba(238, 93, 108, 0.15);\n  color: #EE5D6C;\n  border: 1px solid rgba(238, 93, 108, 0.4);\n}\n\n/* CONTENT */\n.video-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  overflow: hidden;\n}\n\n/* TITLE */\n.video-title {\n  font-weight: 800;\n  font-size: 15px;\n  line-height: 1.2;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  overflow: hidden;\n  height: 40px;\n}\n\n/* DESCRIPTION */\n.video-desc {\n  font-size: 12px;\n  color: #A3AED0;\n  margin-top: 8px;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n\n  overflow: hidden;\n  height: 38px;\n}\n\n/* FOOTER */\n.video-footer {\n  margin-top: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
